var _circle, _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#003D76",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16s-1.5-2-4-2-4 2-4 2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    x2: 9.01,
    y1: 9,
    y2: 9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 15.01,
    y1: 9,
    y2: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.63ecdcf7a429c2165a01d9acc1ff24c9.svg";
export { ForwardRef as ReactComponent };